import React, { useState } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import * as XLSX from "xlsx";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";

const FileUpload = () => {
  const [excelFile, setExcelFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const userId = localStorage.getItem("userId");

  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  const handleFileChange = (e) => {
    setExcelFile(e.target.files[0]);
    setErrors({ ...errors, file: true });
  };

  const handleFileUpload = async () => {
    if (!excelFile) {
      setErrors({ ...errors, file: false });
      handleError("Please select a file first.");
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("file", excelFile);
    formData.append("userId", userId);

    try {
      const response = await axios.post(
        config.APIACTIVATEURL + config.IMPORTCLIENTS,
        formData,
        {
          ...headerconfig,
        }
      );

      if (response.status === 200) {
        handleSuccess(response.data.data);
      } else {
        handleError(response.data);
      }
    } catch (error) {
      if (error.response) {
        handleError(error.response.data);
      } else {
        handleError("Error uploading the file");
      }
    }
  };

  const handleReset = () => {
    setExcelFile(null);
    setErrors({});
    setIsLoading(false);
    document.getElementById("selectFiles").value = "";
  };

  const downloadSampleExcel = () => {
    const sampleData = [
      {
        "S.No": 1,
        "Client Status": "CO-OPERATIVE SOCIETY",
        "Client Code": "CLT001",
        "Group Code": "",
        "Pan Number": "ABCDE1234F",
        "Client Name": "John Smith",
        "Date of Birth": "15-05-1985",
        "Company Name": "ABC Corp",
        "E Mail": "john.smith@example.com",
        "Phone Number": "9876543210",
        Address: "123 Main St, Cityville",
        Status: "ACTIVE",
      },
      {
        "S.No": 2,
        "Client Status": "HUF",
        "Client Code": "CLT002",
        "Group Code": "GRP001",
        "Pan Number": "XYZDE5678G",
        "Client Name": "Sarah Johnson",
        "Date of Birth": "22-11-1990",
        "Company Name": "",
        "E Mail": "sarah.j@example.com",
        "Phone Number": "8765432109",
        Address: "456 Oak Ave, Townsville",
        Status: "ACTIVE",
      },
      {
        "S.No": 3,
        "Client Status": "INDIVIDUAL",
        "Client Code": "CLT003",
        "Group Code": "",
        "Pan Number": "PQRST9012H",
        "Client Name": "Michael Brown",
        "Date of Birth": "03-07-1978",
        "Company Name": "XYZ Ltd",
        "E Mail": "michael.b@example.com",
        "Phone Number": "7654321098",
        Address: "789 Pine Rd, Villageton",
        Status: "INACTIVE",
      },
    ];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(sampleData);
    XLSX.utils.book_append_sheet(wb, ws, "Clients");
    XLSX.writeFile(wb, "client_import_sample.xlsx");
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">File Upload</h4>
                </div>
              </div>
            </div>

            <div className="alert alert-success">
              <form autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="selectFiles" className="form-label">
                        Select Files
                      </label>
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        className={"form-control" + applyErrorClass("file")}
                        id="selectFiles"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleFileUpload}
                      >
                        Import
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleReset}
                        disabled={isLoading}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-info w-100"
                        onClick={downloadSampleExcel}
                      >
                        Download Sample
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2">
            <h4 className="text-muted mb-0">
              Note: Records with the same PAN number Data cannot be imported .
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
